import React, { Component } from 'react';
import { Provider } from 'react-redux';
import * as actions from 'actions';
import * as selectors from 'selectors';
import Fosol from './Fosol';

export default class Root extends Component {
  constructor(props) {
    super(props);
    const store = this.props.store;
    actions.setDispatcher(store.dispatch, store.getState);
    selectors.setDispatcher(store.dispatch, store.getState);
    if (process.env.NODE_ENV === 'development' && window) {
      window.actions = actions;
      window.selectors = selectors;
      window.dispatch = store.dispatch;
      window.getState = store.getState;
    }
  }
  render() {
    return (
      <Provider store={this.props.store}>
        <Fosol />
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Root.js